import { PropsWithChildren } from 'react';

/**
 * Temporary replacement for `React.Fragment` until https://github.com/mui/material-ui/issues/14943 is resolved.
 * TODO remove
 */
export const SceneMenuFragment = ({ children }: PropsWithChildren) => children;
